import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const reducers = {
  setDeliveryRouteDetails: (state, action) => {
    return { ...action.payload };
  },
};

const deliveryRouteDetails = createSlice({
  initialState,
  name: "deliveryRoute",
  reducers,
});

export const { setDeliveryRouteDetails } = deliveryRouteDetails.actions;

export default deliveryRouteDetails;
